import { Avatar, Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography, Divider } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";

const currency = (v: any) => typeof v === 'number' ? v.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }) : v;
const dateFrom = (d: any) => {
    if (!d) return '';
    if (typeof d === 'string') return new Date(d).toLocaleString();
    if (d._seconds) return new Date(d._seconds * 1000).toLocaleString();
    return String(d);
}

const ProductsList = ({ products }: { products?: any[] }) => {
    if (!products || products.length === 0) return <Typography variant="body2">Sin productos</Typography>;
    return (
        <List sx={{ width: '100%' }}>
            {products.map((p: any) => (
                <Paper key={p.id || p.codeBars || Math.random()} sx={{ mb: 1, p: 1 }}>
                    <ListItem disableGutters>
                        <ListItemAvatar>
                            <Avatar src={p.image || ''} alt={p.ItemName || p.label || ''} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={<Typography variant="subtitle2">{p.ItemName || p.label}</Typography>}
                            secondary={<>
                                <Typography variant="body2">Cantidad: {p.cantidad ?? p.totalCantidad ?? '—'}</Typography>
                                <Typography variant="body2">Precio: {p.price ? currency(p.price) : (p.priceIva ? currency(p.priceIva) : '—')}</Typography>
                                {p.onHand !== undefined && <Typography variant="body2">Stock: {String(p.onHand)}</Typography>}
                            </>}
                        />
                    </ListItem>
                </Paper>
            ))}
        </List>
    )
}

const ViewOrder = ({ order, openOrder, setOpenOrder }: { order: any, openOrder: boolean, setOpenOrder: Dispatch<SetStateAction<boolean>> }) => {
    const handleClose = () => setOpenOrder(false);

    if (!order) return (
        <Dialog open={openOrder} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>Detalle de la orden</span>
                <IconButton onClick={handleClose}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2">No hay datos de la orden seleccionada.</Typography>
            </DialogContent>
        </Dialog>
    );

    const { numberOrder, cardName, cardCode, total, docDate, dueDate, status, products, trackingDetails } = order;

    return (
        <Dialog open={openOrder} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">Orden #{numberOrder ?? '—'}</Typography>
                    <Typography variant="subtitle2" color="text.secondary">{` ${cardCode ?? ''} - ${cardName ?? ''}`}</Typography>
                </Box>
                <IconButton onClick={handleClose}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>

                    <Grid size={12}>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">Detalles</Typography>
                            <Box sx={{ mt: 1 }}>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Typography variant="caption" color="text.secondary">Cliente</Typography>
                                        <Typography variant="body2">{cardName ?? cardCode ?? '—'}</Typography>
                                    </Grid>
                                    <Grid size={6}>
                                        <Typography variant="caption" color="text.secondary">Nombre Comercial</Typography>
                                        <Typography variant="body2">{order.cardFName ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={12}>
                                        <Typography variant="caption" color="text.secondary">Dirección</Typography>
                                        <Typography variant="body2">{order.street ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Giro</Typography>
                                        <Typography variant="body2">{order.giro ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">NIT</Typography>
                                        <Typography variant="body2">{order.nit ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">NRC</Typography>
                                        <Typography variant="body2">{order.nrc ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Fecha</Typography>
                                        <Typography variant="body2">{dateFrom(docDate)}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Vence</Typography>
                                        <Typography variant="body2">{dateFrom(dueDate)}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Creado</Typography>
                                        <Typography variant="body2">{dateFrom(order.created_at ?? new Date())}</Typography>
                                    </Grid>


                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Estado</Typography>
                                        <Typography variant="body2">{status ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Tipo de documento</Typography>
                                        <Typography variant="body2">{order.typeDocument ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={4}>
                                        <Typography variant="caption" color="text.secondary">Tipo de pago</Typography>
                                        <Typography variant="body2">{order.typePayment ?? '—'}</Typography>
                                    </Grid>


                                    <Grid size={6}>
                                        <Typography variant="caption" color="text.secondary">Código vendedor</Typography>
                                        <Typography variant="body2">{order.salesPersonCode ?? '—'}</Typography>
                                    </Grid>

                                    <Grid size={6}>
                                        <Typography variant="caption" color="text.secondary">Vendedor</Typography>
                                        <Typography variant="body2">{order.vendorName ?? '—'}</Typography>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">Otra informacion del documento</Typography>
                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                <Grid size={6}>
                                    <Typography variant="caption" color="text.secondary">Bodega</Typography>
                                    <Typography variant="body2">{order.codeCellar ?? '—'}</Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption" color="text.secondary">PayToCode</Typography>
                                    <Typography variant="body2">{order.payToCode ?? '—'}</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography variant="caption" color="text.secondary">Respuesta WebService (Sincronización)</Typography>
                                    <Grid container spacing={1}>
                                        <Grid size={3}>
                                            <Typography variant="caption" color="text.secondary">FDocEntry</Typography>
                                        </Grid>
                                        <Grid size={9}>
                                            <Typography variant="body2">{order.answer_webService?.FDocEntry ?? '—'}</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="caption" color="text.secondary">FDocNum</Typography>
                                        </Grid>
                                        <Grid size={9}>
                                            <Typography variant="body2">{order.answer_webService?.FDocNum ?? '—'}</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="caption" color="text.secondary">eCode</Typography>
                                        </Grid>
                                        <Grid size={9}>
                                            <Typography variant="body2">{order.answer_webService?.eCode ?? '—'}</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="caption" color="text.secondary">eMsg</Typography>
                                        </Grid>
                                        <Grid size={9}>
                                            <Typography variant="body2">{order.answer_webService?.eMsg ?? '—'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">Tracking</Typography>
                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                <Grid size={6}>
                                    <Typography variant="caption" color="text.secondary">Mostro indicador de distancia</Typography>
                                    <Typography variant="body2">{order.showFlagDistance ? 'Sí' : 'No'}</Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption" color="text.secondary">Distancia</Typography>
                                    <Typography variant="body2">{order.trackingDetails && Array.isArray(order.trackingDetails) && order.trackingDetails.length > 0 ? `${order.trackingDetails[0].distance ?? '—'} m` : '—'}</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography variant="caption" color="text.secondary">Detalles de tracking</Typography>
                                    <Grid container spacing={1}>
                                        {trackingDetails && Array.isArray(trackingDetails) ? (
                                            <>
                                                {trackingDetails.map((t: any, i: number) => (
                                                    <Grid size={6} key={i}>
                                                        <Paper sx={{ p: 1 }}>
                                                            <Typography variant="body2">Tipo: {t.type === "init" ? "Inicio" : "Final"}</Typography>
                                                            <Typography variant="body2">Distancia: {t.distance ?? '—'}</Typography>
                                                            {t.vendorPosition && <Typography variant="body2">Pos [lat, long]: {t.vendorPosition._latitude}, {t.vendorPosition._longitude}</Typography>}
                                                            <Typography variant="body2">Creado: {dateFrom(t.created)}</Typography>
                                                        </Paper>
                                                    </Grid>
                                                ))}
                                            </>
                                        ) : <Typography variant="body2">—</Typography>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ mb: 2 }}>

                            <Typography variant="subtitle2">Resumen</Typography>
                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                <Grid size={6}><Typography variant="caption" color="text.secondary">Total de Lineas</Typography><Typography>{currency(total)}</Typography></Grid>
                                <Grid size={6}><Typography variant="caption" color="text.secondary">IVA</Typography><Typography>{currency(order.iva)}</Typography></Grid>
                                <Grid size={6}><Typography variant="caption" color="text.secondary">Retencion</Typography><Typography>{currency(order.retention)}</Typography></Grid>
                                <Grid size={6}><Typography variant="caption" color="text.secondary">Total</Typography><Typography>{currency(order.totalIva)}</Typography></Grid>
                            </Grid>
                        </Box>

                        <Divider sx={{ my: 1 }} />

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">Productos</Typography>
                            <ProductsList products={products} />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent >
        </Dialog >
    )
}

export default ViewOrder;